import type { ChatEntityPreviewEmbed, ChatEntitySearchResultsEmbed } from "./types";

export type EntityPreviewCardKind = ChatEntitySearchResultsEmbed["kind"] | ChatEntityPreviewEmbed["kind"];

export function buildEntitySearchResultsCardKey(
  messageId: string,
  embed: ChatEntitySearchResultsEmbed,
  index: number,
): string {
  return `${messageId}:entity_search_results:${embed.entity_type}:${index}`;
}

export function buildEntityPreviewCardKey(
  messageId: string,
  embed: ChatEntityPreviewEmbed,
  index: number,
): string {
  return `${messageId}:entity_preview:${embed.entity_type}:${embed.id}:${index}`;
}
